export default __webpack_public_path__ + "static/media/28-large.f09f5c95.jpg";